/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyDocumentStatus = {
  type: 'Enum',
} as const;
